import React, { Component } from "react";
import { View, StyleSheet, Dimensions, Platform } from "react-native";
import Text from "./TextFont";
import Spinner from "./Spinner";
import { connect } from "react-redux";
import { translate } from "../locales/translate";
import Theme from "../argon-ui/Theme";
import ModalBase from "../nativeBase-ui/ModalBase";
/**
 * @augments{Component<props, state>}
 */
const SCREEN_WIDTH = Dimensions.get("window").width;
class ConnectionChecker extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.AppReducer.showSplashScreen) {
      typeof nextProps.onMaxRetryExceeded == "function" &&
        nextProps.onMaxRetryExceeded();
    }
    return null;
  }
  render() {
    if (this.props.AppReducer.showSplashScreen !== this.props.prevState) {
      typeof this.props.parentCallBack == "function" &&
        this.props.parentCallBack(this.props.AppReducer.showSplashScreen);
    }
    return (
      <ModalBase
        avoidKeyboard={true}
        isOpen={!this.props.AppReducer.connected}
        closeButton={false}
        contentStyle={{ height: 140 }}
      >
        <View style={styles.container}>
          <View style={styles.modalContent}>
            <View style={{ width: 20, height: 20 }}>
              <Spinner size={50} />
            </View>
            {/* <ActivityIndicator size="large" color={Theme.COLORS.PRIMARY} /> */}
            <Text style={styles.title}>{translate("app.connecting")}</Text>
          </View>
        </View>
      </ModalBase>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    //flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "80%",
    alignSelf: "center",
    borderRadius: 5,
    height: 140,
    paddingTop:10,
    flex: 1,
  },
  modalContent: {
    alignItems: "center",
    justifyContent: "center",
    height: 100,
    marginTop: Platform.OS == "web" || Platform.OS == "android" ? 0 : 140,
  },
  title: {
    fontSize: 18,
    color: Theme.COLORS.DARK,
    marginTop: 30,
  },
});

const mapStateToProps = (state) => {
  return {
    AppReducer: state.AppReducer,
  };
};

export default connect(mapStateToProps)(ConnectionChecker);
